<template>
  <div>
    <div class="card">
      <div class="card-header"><h4>Cadastrar Colaborador</h4></div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-2">
            <label for="id">Cód. Sistema</label>
            <input
              id="id"
              type="text"
              class="form-control"
              v-model="state.id"
              readonly
            />
          </div>
          <div class="col-md-4">
            <label for="nome">Nome</label>
            <input
              id="nome"
              type="text"
              class="form-control"
              placeholder="Digite um nome"
              v-model="state.nome.value"
            />
            <span v-if="state.nome.error" class="text-danger"
              >Este campo é obrigatório</span
            >
          </div>
          <div class="col-md-3">
            <label for="telefone">Telefone</label>
            <input
              id="telefone"
              type="text"
              class="form-control"
              v-model="state.telefone.value"
              v-mask-phone.br
            />
            <span v-if="state.telefone.error" class="text-danger"
              >Este campo é obrigatório</span
            >
          </div>
          <div class="col-md-2">
            <label for="status">Status</label>
            <select v-model="state.status" class="form-select" id="status">
              <option value="" selected disabled>Selecione</option>
              <option value="ATIVO">Ativo</option>
              <option value="INATIVO">Inativo</option>
            </select>
          </div>
        </div>

        <label>Informações de Acesso</label>
        <div class="row">
          <div class="col-md-3">
            <label>CPF</label>
            <input type="text" class="form-control" v-model="state.cpf.value" maxlength="14" v-mask-cpf/>
            <span v-if="state.telefone.error" class="text-danger"
              >Este campo é obrigatório</span
            >
          </div>
          <div class="col-md-3">
            <label>Senha</label>
            <input type="password" class="form-control" v-model="state.senha" />
          </div>
          <div class="col-md-3">
            <label>Administrador</label>
            <select class="form-select" v-model="state.admin">
              <option value="SIM">Sim</option>
              <option value="NAO">Não</option>
            </select>
          </div>
        </div>

        <div class="btns_right">
          <button @click="salvar" type="button" class="btn_save">Salvar</button>
          <router-link to="/admin/colaboradores">
            <button type="button" class="btn_cancel">Cancelar</button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { onMounted, reactive } from "vue";
import { useRouter } from "vue-router";
import services from "../../services";
import { useStorage } from "vue3-storage";
export default {
  setup() {
    const router = useRouter();
    const storage = useStorage();
    var token = storage.getStorageSync("token");
    const state = reactive({
      id: "",
      nome: {
        value: "",
        error: false,
      },
      cpf: {
        value: "",
        error: false,
      },
      telefone: {
        value: "",
        error: false,
      },
      colaborador:"NAO",
      status: "ATIVO",
    });
    onMounted(() => {
      if (router.currentRoute._value.params.id != undefined) {
        fetch();
      }
    });
    async function fetch() {
      try {
        const { data } = await services.colaboradores.getById({
          id: router.currentRoute._value.params.id,
          token,
        });
        state.id = data.id;
        state.nome.value = data.nome;
        state.telefone.value = data.telefone;
        state.admin = data.admin;
        state.status = data.status;
        state.cpf.value = data.cpf;
      } catch (error) {
        console.log(error);
      }
    }
    async function salvar() {
      var erro_validacao = false;

      if (state.nome.value.length == 0) {
        state.nome.error = true;
        erro_validacao = true;
      }

      if (erro_validacao == true) {
        return;
      }
      if (!state.id) {
        await services.colaboradores
          .save({
            nome: state.nome.value,
            cpf: state.cpf.value.replace(/[^\d]/g, ''),
            senha: state.senha,
            telefone: state.telefone.value,
            status: state.status,
            admin: state.admin,
            token,
          })
          .then(() => {
            router.push({ name: "Colaboradores" });
          })
          .catch((error) => {
            console.log(error)
          });
      } else {
        await services.colaboradores
          .update({
            id: state.id,
            nome: state.nome.value,
            cpf: state.cpf.value.replace(/[^\d]/g, ''),
            telefone: state.telefone.value,
            status: state.status,
            admin: state.admin,
            senha: state.senha,
            token,
          })
          .then(() => {
            router.push({ name: "Colaboradores" });
          })
          .catch((error) => {
            var valores = Object.values(error.response.data.errors);
            alert(valores);
          });
      }
    }
    return {
      salvar,
      router,
      state,
    };
  },
};
</script>
<style scoped>
h4 {
  color: #000;
}
label {
  color: #000;
  font-size: 12pt;
  margin-bottom: 0;
  margin-top: 5px;
}
input {
  border: solid 1px #000;
}
input:focus {
  border: solid 1px #0a516d;
}
select {
  border: solid 1px #000;
}
select:focus {
  border: solid 1px #0a516d;
}
.btns_right {
  text-align: right;
  margin-top: 1rem;
}
.div_acesso {
  margin-bottom: 20px;
}
.div_acesso #acesso_sim {
  margin-left: 10px;
}
.btn_save {
  padding: 5px;
  width: 100px;
  color: #fff;
  background: #56008f;
  border: solid 2px #56008f;
  border-radius: 5px;
  transition: 0.2s;
}
.btn_save:hover {
  filter: brightness(1.5);
}
.btn_cancel {
  padding: 5px;
  width: 100px;
  background-color: transparent;
  color: #56008f;
  border: solid 2px #56008f;
  border-radius: 5px;
  margin-left: 10px;
  transition: 0.2s;
}
.btn_cancel:hover {
  background: #56008f;
  color: #fff;
  filter: brightness(1.5);
}
.card {
  border: solid 2px #000;
  border-radius: 10px;
  background-color: #fff;
}
textarea {
  resize: none;
  border: solid 1px #000;
}
textarea:focus {
  border: solid 1px #0a516d;
}
#pills-home-tab {
  color: #000;
}
#pills-home-tab:focus {
  color: #0a516d;
}
#pills-profile-tab {
  color: #000000;
}
#pills-profile-tab:focus {
  color: #0a516d;
}
.btn-add {
  color: #000;
  padding: 5px;
  width: 100px;
  background: orange;
  border: solid 2px #000;
  border-radius: 5px;
  margin-left: 10px;
  transition: 0.2s;
}
.btn-add:hover {
  background: rgb(208, 135, 1);
  color: #000;
}
tr {
  border-bottom: solid 1px rgb(0, 0, 0);
}
thead {
  color: #000;
  text-align: center;
  background: gray;
}
td {
  color: #000;
  text-align: center;
}
.table {
  margin-top: 2rem;
}
.imagem {
  width: 100%;
  height: auto;
  -o-object-fit: cover;
  object-fit: cover;
  margin-top: 2rem;
  border: solid 2px #4bafa9;
}
.btn_deletar_imagem {
  margin-left: 10px;
  height: 30px;
  width: 30px;
  margin-top: 2rem;
  background: #c4342d;
  color: #000;
  border: solid 1px #000;
  border-radius: 5px;
  transition: 0.2s;
}
.btn_deletar_imagem:hover {
  background: #8f0303;
  border: solid 1px #000;
}
</style>